import { DutyRequirementsState } from './types';
import {
  FETCH_DUTY_REQUIREMENTS_REQUEST,
  FETCH_DUTY_REQUIREMENTS_SUCCESS,
  FETCH_DUTY_REQUIREMENTS_FAILURE,
  DUTY_COMPLIANCE_UPDATED,
  DutyComplianceUpdatedPayload
} from './actions';

const initialState: DutyRequirementsState = {
  data: {},
  compliance: {},
  loading: false,
  error: null,
};

export const dutyRequirementsReducer = (
  state = initialState,
  action: any
): DutyRequirementsState => {
  switch (action.type) {
    case FETCH_DUTY_REQUIREMENTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DUTY_REQUIREMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [action.payload.siteId]: action.payload.requirements,
        },
      };
    case FETCH_DUTY_REQUIREMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case DUTY_COMPLIANCE_UPDATED: {
      const payload = action.payload as DutyComplianceUpdatedPayload;
      
      // Store backend-calculated compliance data separately from requirements
      // This allows the selectors to prioritize real-time calculated data
      return {
        ...state,
        compliance: {
          ...state.compliance,
          [payload.siteId]: payload.compliance,
        },
      };
    }
    default:
      return state;
  }
};

export default dutyRequirementsReducer;
